
  import {getMetaTags} from '@/helper/Seo';
  import {mapSectionComponents} from '@/helper/SectionHelper';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'Wiki',
    components: {
      LazyHydrate,
    },
    layout: 'organization',
    async asyncData({error, route, $cachedStrapi, app}) {
      // Query page from Strapi; strapi-change for findOne is required!
      const pagePromise = $cachedStrapi
        .findOne('pages', 'organization-wikis-slug')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      // Query Wiki from Strapi based on slug; strapi-change for findOne is required!
      const wikiPromise = $cachedStrapi
        .findOne('wikis', route.params.slug)
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      const [page, wiki] = await Promise.all([pagePromise, wikiPromise]);

      if (!scopeHelper(page, process.env.SCOPE_ORGANIZATION)) {
        error({statusCode: 404, message: 'Page not found'});
        return;
      }

      const sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionWikiDetails':
              section.wiki = wiki;
              break;

            case 'SectionHomepageJobBoxWithTabs':
            case 'SectionJobBoxWithoutTabs':
              if (!wiki.filterParams) {
                section.filterParams = {};
              }
              section.filterParams = wiki.filterParams;

              if (section.base_data && section.base_data.title) {
                section.base_data.title = section.base_data.title.replace(
                  /%wiki_name/g,
                  wiki.title.toUpperCase()
                );
              }

              if (section.base_data && section.base_data.intro_text) {
                section.base_data.intro_text =
                  section.base_data.intro_text.replace(
                    /%wiki_name/g,
                    wiki.title
                  );
              }

              if (section.base_data && section.base_data.finish_text) {
                section.base_data.finish_text =
                  section.base_data.finish_text.replace(
                    /%wiki_name/g,
                    wiki.title
                  );
              }
              break;

            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'organization',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.wikis'),
                  disabled: false,
                  to: app.localePath({
                    name: 'organization-wikis',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: wiki.title,
                  disabled: true,
                  to: app.localePath({
                    name: 'organization-wikis-slug',
                    params: {
                      slug: wiki.slug,
                    },
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionSeoContent':
              if (
                wiki.seo_content_config &&
                wiki.seo_content_config.seo_contents &&
                wiki.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  wiki.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );

      const metaData =
        wiki && wiki.meta ? wiki.meta : page && page.meta ? page.meta : {};

      return {
        metaData,
        sections,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
      };
    },
    head() {
      // Wikis gehen im Canonical immer auf den Jobsuchenden-Kontext
      const canonical_links = [];

      const canonical_url =
        process.env.NUXT_ENV_BASE_URL +
        this.localePath({
          name: 'wikis-slug',
          params: {
            slug: this.$route.params.slug,
          },
        });

      canonical_links.push({
        rel: 'canonical',
        hid: 'canonical',
        href: canonical_url,
      });

      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
        link: canonical_links,
      };
    },
  };
